import { UPDATE_WINDOW_SCROLL_TOP } from './FrontDoorsPageContainer.actions';

export const reducer = (state, action) => {
  switch (action.type) {
    case UPDATE_WINDOW_SCROLL_TOP: {
      const { windowScrollTop } = action.payload;
      return {
        ...state,
        windowScrollTop
      };
    }
    default: {
      return { ...state };
    }
  }
};

export default { reducer };
